<template>
  <div>
    <h4 class="form-title">Грузовая накладная</h4>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="IssueInfo_IATACode"
          inputId="IssueInfo_IATACode"
          inputName="Код ИАТА"
          :inputValidationRules="{ max: 3 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="iata"
          select="iata"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="RegNum"
          :name="'№ документа'"
          :rules="{ required: true }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-1"
            label="№ документа"
            label-for="input-1"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!airWaybillForm.RegNum), 'empty-field': !(!!airWaybillForm.RegNum) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-1"
              :class="{ 'form-input': true, 'filled-field': (!!airWaybillForm.RegNum), 'required-field': !(!!airWaybillForm.RegNum) }"
              v-model="airWaybillForm.RegNum"
              placeholder="№ документа"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <h4 class="form-title">Отправитель</h4>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="Consignor_Name"
          name="Наименование отправителя"
          :rules="{ required: true, max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-15"
            label="Наименование отправителя"
            label-for="input-15"
            :label-class="(!!airWaybillForm.Consignor_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-15"
              :class="{ 'form-input': true, 'filled-field': (!!airWaybillForm.Consignor_Name), 'required-field': !(!!airWaybillForm.Consignor_Name) }"
              v-model="airWaybillForm.Consignor_Name"
              placeholder="Наименование отправителя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="сConsignor_Phone"
          name="Телефон отправителя"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-10"
            label="Телефон"
            label-for="input-10"
            :label-class="(!!airWaybillForm.Consignor_Phone) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-10"
              :class="(!!airWaybillForm.Consignor_Phone) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignor_Phone"
              placeholder="Телефон"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="Consignor_Email"
          name="Электронная почта отправителя"
          :rules="{ max: 35, regex: /^[^@]+@\w+(\.\w+)+\w$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-11"
            label="Электронная почта"
            label-for="input-11"
            :label-class="(!!airWaybillForm.Consignor_Email) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-11"
              :class="(!!airWaybillForm.Consignor_Email) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignor_Email"
              placeholder="Электронная почта"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignor_INN"
          :name="'ИНН отправителя'"
          :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-13"
            label="ИНН"
            label-for="input-13"
            :label-class="(!!airWaybillForm.Consignor_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-13"
              :class="(!!airWaybillForm.Consignor_INN) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignor_INN"
              placeholder="ИНН"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignor_KPP"
          :name="'КПП отправителя'"
          :rules="{ max: 9, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-14"
            label="КПП"
            label-for="input-14"
            :label-class="(!!airWaybillForm.Consignor_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-14"
              :class="(!!airWaybillForm.Consignor_KPP) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignor_KPP"
              placeholder="КПП"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="4" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignor_OGRN"
          :name="'ОГРН отправителя'"
          :rules="{ max: 15, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-15"
            label="ОГРН"
            label-for="input-15"
            :label-class="(!!airWaybillForm.Consignor_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-15"
              :class="(!!airWaybillForm.Consignor_OGRN) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignor_OGRN"
              placeholder="ОГРН"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Consignor_CountryCode"
          inputId="Consignor_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignor_CountryCode: 'abc2' },
            { Consignor_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Consignor_CountryName"
          inputId="Consignor_CountryName"
          inputName="Наименование страны отправителя"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignor_CountryCode: 'abc2' },
            { Consignor_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignor_PostalCode"
          :name="'Индекс отправителя'"
          :rules="{ max: 9, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-18"
            label="Почтовый индекс"
            label-for="input-18"
            :label-class="(!!airWaybillForm.Consignor_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-18"
              :class="(!!airWaybillForm.Consignor_PostalCode) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignor_PostalCode"
              placeholder="Почтовый индекс"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Consignor_Region"
          inputId="Consignor_Region"
          inputName="Область (регион, штат, провинция и т.п.) отправителя"
          type="simple"
          :disabled="notForEdit"
          :inputValidationRules="{ max: 150 }"
          :edited="true"
          :required="false"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignor_City"
          :name="'Населенный пункт отправителя'"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-20"
            label="Населенный пункт"
            label-for="input-20"
            :label-class="(!!airWaybillForm.Consignor_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-20"
              :class="(!!airWaybillForm.Consignor_City) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignor_City"
              placeholder="Населенный пункт"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Consignor_StreetHouse"
          inputId="Consignor_StreetHouse"
          inputName="Улица, номер дома, номер офиса"
          type="simple"
          :disabled="notForEdit"
          :inputValidationRules="{ max: 50 }"
          :edited="true"
          :required="false"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <h4 class="form-title">Получатель</h4>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="Consignee_Name"
          name="Наименование получателя"
          :rules="{ required: true, max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-15"
            label="Наименование получателя"
            label-for="input-15"
            :label-class="(!!airWaybillForm.Consignee_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-15"
              :class="{ 'form-input': true, 'filled-field': (!!airWaybillForm.Consignee_Name), 'required-field': !(!!airWaybillForm.Consignee_Name) }"
              v-model="airWaybillForm.Consignee_Name"
              placeholder="Наименование получателя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="Consignee_Phone"
          name="Телефон получателя"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-10"
            label="Телефон"
            label-for="input-10"
            :label-class="(!!airWaybillForm.Consignee_Phone) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-10"
              :class="(!!airWaybillForm.Consignee_Phone) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignee_Phone"
              placeholder="Телефон"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="Consignee_Email"
          name="Электронная почта получателя"
          :rules="{ max: 35, regex: /^[^@]+@\w+(\.\w+)+\w$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-11"
            label="Электронная почта"
            label-for="input-11"
            :label-class="(!!airWaybillForm.Consignee_Email) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-11"
              :class="(!!airWaybillForm.Consignee_Email) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignee_Email"
              placeholder="Электронная почта"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignee_INN"
          :name="'ИНН получателя'"
          :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-23"
            label="ИНН"
            label-for="input-23"
            :label-class="(!!airWaybillForm.Consignee_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-23"
              :class="(!!airWaybillForm.Consignee_INN) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignee_INN"
              placeholder="ИНН"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignee_KPP"
          :name="'КПП получателя'"
          :rules="{ max: 9, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-24"
            label="КПП"
            label-for="input-24"
            :label-class="(!!airWaybillForm.Consignee_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-24"
              :class="(!!airWaybillForm.Consignee_KPP) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignee_KPP"
              placeholder="КПП"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="4" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignee_OGRN"
          :name="'ОГРН получателя'"
          :rules="{ max: 15, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-25"
            label="ОГРН"
            label-for="input-25"
            :label-class="(!!airWaybillForm.Consignee_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-25"
              :class="(!!airWaybillForm.Consignee_OGRN) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Consignee_OGRN"
              placeholder="ОГРН"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Consignee_CountryCode"
          inputId="Consignee_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_CountryCode: 'abc2' },
            { Consignee_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Consignee_CountryName"
          inputId="Consignee_CountryName"
          inputName="Наименование страны получателя"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_CountryCode: 'abc2' },
            { Consignee_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignee_PostalCode"
            :name="'Индекс получателя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-28"
              label="Почтовый индекс"
              label-for="input-28"
              :label-class="(!!airWaybillForm.Consignee_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-28"
                :class="(!!airWaybillForm.Consignee_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="airWaybillForm.Consignee_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignee_Region"
            inputId="Consignee_Region"
            inputName="Область (регион, штат, провинция и т.п.) получателя"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignee_City"
            :name="'Населенный пункт получателя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-30"
              label="Населенный пункт"
              label-for="input-30"
              :label-class="(!!airWaybillForm.Consignee_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-30"
                :class="(!!airWaybillForm.Consignee_City) ? 'form-input filled-field' : 'form-input'"
                v-model="airWaybillForm.Consignee_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignee_StreetHouse"
            inputId="Consignee_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <h4 class="form-title">Авиакомпания, выписавшая накладную</h4>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="IssueInfo_Name"
          name="Наименование авиакомпании"
          :rules="{ required: true, max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-15"
            label="Наименование авиакомпании"
            label-for="input-15"
            :label-class="(!!airWaybillForm.IssueInfo_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-15"
              :class="{ 'form-input': true, 'filled-field': (!!airWaybillForm.IssueInfo_Name), 'required-field': !(!!airWaybillForm.IssueInfo_Name) }"
              v-model="airWaybillForm.IssueInfo_Name"
              placeholder="Наименование авиакомпании"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="IssueInfo_Phone"
          name="Телефон"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-10"
            label="Телефон"
            label-for="input-10"
            :label-class="(!!airWaybillForm.IssueInfo_Phone) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-10"
              :class="(!!airWaybillForm.IssueInfo_Phone) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssueInfo_Phone"
              placeholder="Телефон"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="IssueInfo_Email"
          name="Электронная почта"
          :rules="{ max: 35, regex: /^[^@]+@\w+(\.\w+)+\w$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-11"
            label="Электронная почта"
            label-for="input-11"
            :label-class="(!!airWaybillForm.IssueInfo_Email) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-11"
              :class="(!!airWaybillForm.IssueInfo_Email) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssueInfo_Email"
              placeholder="Электронная почта"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="IssueInfo_INN"
            :name="'ИНН'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-23"
              label="ИНН"
              label-for="input-23"
              :label-class="(!!airWaybillForm.IssueInfo_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-23"
                :class="(!!airWaybillForm.IssueInfo_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="airWaybillForm.IssueInfo_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="IssueInfo_KPP"
            :name="'КПП'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-24"
              label="КПП"
              label-for="input-24"
              :label-class="(!!airWaybillForm.IssueInfo_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-24"
                :class="(!!airWaybillForm.IssueInfo_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="airWaybillForm.IssueInfo_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="IssueInfo_OGRN"
            :name="'ОГРН'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-25"
              label="ОГРН"
              label-for="input-25"
              :label-class="(!!airWaybillForm.IssueInfo_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-25"
                :class="(!!airWaybillForm.IssueInfo_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="airWaybillForm.IssueInfo_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="IssueInfo_CountryCode"
          inputId="IssueInfo_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { IssueInfo_CountryCode: 'abc2' },
            { IssueInfo_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="IssueInfo_CountryName"
          inputId="IssueInfo_CountryName"
          inputName="Наименование страны"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { IssueInfo_CountryCode: 'abc2' },
            { IssueInfo_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="IssueInfo_PostalCode"
          :name="'Индекс'"
          :rules="{ max: 9, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-28"
            label="Почтовый индекс"
            label-for="input-28"
            :label-class="(!!airWaybillForm.IssueInfo_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-28"
              :class="(!!airWaybillForm.IssueInfo_PostalCode) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssueInfo_PostalCode"
              placeholder="Почтовый индекс"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="IssueInfo_Region"
          inputId="IssueInfo_Region"
          inputName="Область (регион, штат, провинция и т.п.)"
          type="simple"
          :disabled="notForEdit"
          :inputValidationRules="{ max: 150 }"
          :edited="true"
          :required="false"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="IssueInfo_City"
          :name="'Населенный пункт получателя'"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-30"
            label="Населенный пункт"
            label-for="input-30"
            :label-class="(!!airWaybillForm.IssueInfo_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-30"
              :class="(!!airWaybillForm.IssueInfo_City) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssueInfo_City"
              placeholder="Населенный пункт"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="IssueInfo_StreetHouse"
          inputId="IssueInfo_StreetHouse"
          inputName="Улица, номер дома, номер офиса"
          type="simple"
          :disabled="notForEdit"
          :inputValidationRules="{ max: 50 }"
          :edited="true"
          :required="false"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row class="mt-2 text-right">
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <b-button class="collapsed" @click="collapseCarrierVisible = !collapseCarrierVisible" variant="link">Агент выпускающего перевозчика</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-delivery" v-model="collapseCarrierVisible" class="pt-3">
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="IssuingCarrier_Name"
          name="Наименование"
          :rules="{ max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-15"
            label="Наименование"
            label-for="input-15"
            :label-class="(!!airWaybillForm.IssuingCarrier_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-15"
              :class="{ 'form-input': true, 'filled-field': (!!airWaybillForm.IssuingCarrier_Name) }"
              v-model="airWaybillForm.IssuingCarrier_Name"
              placeholder="Наименование"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="IssuingCarrier_Phone"
          name="Телефон"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-10"
            label="Телефон"
            label-for="input-10"
            :label-class="(!!airWaybillForm.IssuingCarrier_Phone) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-10"
              :class="(!!airWaybillForm.IssuingCarrier_Phone) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssuingCarrier_Phone"
              placeholder="Телефон"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="IssuingCarrier_Email"
          name="Электронная почта"
          :rules="{ max: 35, regex: /^[^@]+@\w+(\.\w+)+\w$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-11"
            label="Электронная почта"
            label-for="input-11"
            :label-class="(!!airWaybillForm.IssuingCarrier_Email) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-11"
              :class="(!!airWaybillForm.IssuingCarrier_Email) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssuingCarrier_Email"
              placeholder="Электронная почта"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="IssuingCarrier_INN"
          :name="'ИНН'"
          :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-23"
            label="ИНН"
            label-for="input-23"
            :label-class="(!!airWaybillForm.IssuingCarrier_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-23"
              :class="(!!airWaybillForm.IssuingCarrier_INN) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssuingCarrier_INN"
              placeholder="ИНН"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="IssuingCarrier_KPP"
          :name="'КПП получателя'"
          :rules="{ max: 9, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-24"
            label="КПП"
            label-for="input-24"
            :label-class="(!!airWaybillForm.IssuingCarrier_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-24"
              :class="(!!airWaybillForm.IssuingCarrier_KPP) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssuingCarrier_KPP"
              placeholder="КПП"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="4" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="IssuingCarrier_OGRN"
          :name="'ОГРН'"
          :rules="{ max: 15, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-25"
            label="ОГРН"
            label-for="input-25"
            :label-class="(!!airWaybillForm.IssuingCarrier_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-25"
              :class="(!!airWaybillForm.IssuingCarrier_OGRN) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssuingCarrier_OGRN"
              placeholder="ОГРН"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="IssuingCarrier_CountryCode"
          inputId="IssuingCarrier_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { IssuingCarrier_CountryCode: 'abc2' },
            { IssuingCarrier_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="IssuingCarrier_CountryName"
          inputId="IssuingCarrier_CountryName"
          inputName="Наименование страны"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { IssuingCarrier_CountryCode: 'abc2' },
            { IssuingCarrier_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="IssuingCarrier_PostalCode"
          :name="'Индекс'"
          :rules="{ max: 9, regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-28"
            label="Почтовый индекс"
            label-for="input-28"
            :label-class="(!!airWaybillForm.IssuingCarrier_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-28"
              :class="(!!airWaybillForm.IssuingCarrier_PostalCode) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssuingCarrier_PostalCode"
              placeholder="Почтовый индекс"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="IssuingCarrier_Region"
          inputId="IssuingCarrier_Region"
          inputName="Область (регион, штат, провинция и т.п.)"
          type="simple"
          :disabled="notForEdit"
          :inputValidationRules="{ max: 150 }"
          :edited="true"
          :required="false"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="IssuingCarrier_City"
          :name="'Населенный пункт'"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-30"
            label="Населенный пункт"
            label-for="input-30"
            :label-class="(!!airWaybillForm.IssuingCarrier_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-30"
              :class="(!!airWaybillForm.IssuingCarrier_City) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.IssuingCarrier_City"
              placeholder="Населенный пункт"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="IssuingCarrier_StreetHouse"
          inputId="IssuingCarrier_StreetHouse"
          inputName="Улица, номер дома, номер офиса"
          type="simple"
          :disabled="notForEdit"
          :inputValidationRules="{ max: 50 }"
          :edited="true"
          :required="false"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
     </b-row>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="IssuingCarrier_IATACode"
          inputId="IssuingCarrier_IATACode"
          inputName="Код ИАТА"
          :inputValidationRules="{ max: 3 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="iata"
          select="iata"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="IssuingCarrier_CommissionFlag"
          inputId="IssuingCarrier_CommissionFlag"
          inputName="Сведения о  комиссионных для агента"
          :inputItems="commissionFlagTypes"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
             { key: 'value', label: 'Код' },
             { key: 'text', label: 'Тип' }
           ]"
          select="value"
          :loadOnFocus="true"
          :getData="() => { return promise.resolve() }"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    </b-collapse>
    <h4 class="form-title">Аэропорт отправления / адрес первого перевозчика и маршрут</h4>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="DepPoint_IATACode"
          inputId="DepPoint_IATACode"
          inputName="ИАТА"
          :inputValidationRules="{ max: 3 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { DepPoint_Name: 'name_rus' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="iata"
          select="iata"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="DepPoint_Name"
          inputId="DepPoint_Name"
          inputName="Наименование"
          :inputValidationRules="{ max: 80 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { DepPoint_IATACode: 'iata' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="name"
          select="name_rus"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row v-for="(item, index) in airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM" :key="index">
      <b-col xl="1" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          :ref="'NumPP-' + index"
          :name="'№-' + index"
          :rules="{ max: 250 }"
          v-slot="validationContext">
          <b-form-group
            :id="'input-group-62-' + index"
            label="№"
            :label-for="'input-62-' + index"
            :label-class="(!!item.NumPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :id="'input-62-' + index"
              :class="(!!item.NumPP) ? 'form-input filled-field' : 'form-input'"
              v-model="item.NumPP"
              placeholder="№"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="1" lg="4" md="4" sm="4" cols="12">
        <custom-input
        :ref="'CarrierCode-' + index"
        :inputId="'CarrierCode-' + index"
        :inputName="'ИАТА'"
        :index="index"
        :inputValidationRules="{ max: 3 }"
        :inputItems="nsiAirports"
        :targetInput="targetInput"
        :inputFields="[
          { key: 'iata', label: 'Код' },
          { key: 'name_rus', label: 'Наименование' },
          { key: 'city_rus', label: 'Город' }
        ]"
        :inputRelatedFields="[
          { CarrierName: 'name_rus' },
        ]"
        :getData="loadNsiAirports"
        :disabled="notForEdit"
        :delay="1"
        query="iata"
        select="iata"
        @setForm="setModel($event)"
        @setRelatedFields="setRelated($event)"
        @setTargetInput="$emit('setTarget', $event)"
        @closeRefs="$emit('closeRefs')"
        @setRefVisible="$emit('setVisible', $event)"
      ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          :ref="'CarrierName-' + index"
          :inputId="'CarrierName-' + index"
          :inputName="'Наименование перевозчика'"
          :index="index"
          :inputValidationRules="{ max: 80 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { CarrierCode: 'iata' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="name"
          select="name_rus"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="1" lg="4" md="4" sm="4" cols="12">
        <custom-input
        :ref="'IATACode-' + index"
        :inputId="'IATACode-' + index"
        :inputName="'ИАТА назн.'"
        :inputValidationRules="{ max: 3 }"
        :index="index"
        :inputItems="nsiAirports"
        :targetInput="targetInput"
        :inputFields="[
          { key: 'iata', label: 'Код' },
          { key: 'name_rus', label: 'Наименование' },
          { key: 'city_rus', label: 'Город' }
        ]"
        :getData="loadNsiAirports"
        :disabled="notForEdit"
        :delay="1"
        query="iata"
        select="iata"
        @setForm="setModel($event)"
        @setRelatedFields="setRelated($event)"
        @setTargetInput="$emit('setTarget', $event)"
        @closeRefs="$emit('closeRefs')"
        @setRefVisible="$emit('setVisible', $event)"
      ></custom-input>
      </b-col>
      <b-col xl="1" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="FlightNumber"
          :name="'Номер рейса'"
          v-slot="validationContext">
          <b-form-group
            id="input-group-25"
            label="Номер рейса"
            label-for="input-25"
            :label-class="(!!item.FlightNumber) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-25"
              :class="(!!item.FlightNumber) ? 'form-input filled-field' : 'form-input'"
              v-model="item.FlightNumber"
              placeholder="Номер рейса"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <div class="d-flex align-items-start">
          <custom-datepicker
            :ref="'FlightDateNew-' + index"
            :inputId="'FlightDateNew-' + index"
            :inputName="'День вылета'"
            :index="index"
            :disabled="notForEdit"
            :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
            @setForm="setModel($event)"
            @updateIdbData="updateIdbData"
          ></custom-datepicker>
          <b-button :disabled="notForEdit" @click="removePermissiveDocuments(index)" :class="{ 'ml-3': true, 'mr-3': index === (airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM.length - 1) }" squared size="sm" variant="outline-secondary">
            <font-awesome-icon icon="fa-solid fa-minus" />
          </b-button>
          <b-button :disabled="notForEdit" v-if="index === (airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM.length - 1)" @click="addDocuments" squared size="sm" variant="outline-success">
            <font-awesome-icon icon="fa-solid fa-plus" />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <h4 class="form-title">Аэропорт назначения</h4>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="DestPoint_IATACode"
          inputId="DestPoint_IATACode"
          inputName="ИАТА"
          :inputValidationRules="{ max: 3 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { DestPoint_Name: 'name_rus' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="iata"
          select="iata"
          :required="true"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="DestPoint_Name"
          inputId="DestPoint_Name"
          inputName="Наименование"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { DestPoint_IATACode: 'iata' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="name"
          select="name_rus"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <h4 class="form-title">Таможенный орган назначения</h4>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="DestinationOfficeIdentifier"
          name="Код таможенного органа"
          :rules="{ max: 250 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-62"
            label="Код таможенного органа"
            label-for="input-62"
            :label-class="(!!airWaybillForm.DestinationOfficeIdentifier) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-62"
              :class="(!!airWaybillForm.DestinationOfficeIdentifier) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.DestinationOfficeIdentifier"
              placeholder="Код таможенного органа"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <validation-provider
          ref="DestinationOfficeName"
          name="Наименование таможенного органа"
          :rules="{ max: 250 }"
          v-slot="validationContext">
          <b-form-group
            id="'input-group-62'"
            label="Наименование таможенного органа"
            label-for="input-62"
            :label-class="(!!airWaybillForm.DestinationOfficeName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-62"
              :class="(!!airWaybillForm.DestinationOfficeName) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.DestinationOfficeName"
              placeholder="Наименование таможенного органа"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
        <b-row class="mt-2 text-right">
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <b-button class="collapsed" @click="collapseAWBHandlingVisible = !collapseAWBHandlingVisible" variant="link">Информация по обработке груза</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-delivery" v-model="collapseAWBHandlingVisible" class="pt-3">
    <div v-for="(item, index) in airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM" :key="index">
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="ServiceInfoCode"
          name="Код информации"
          :rules="{ max: 250 }"
          v-slot="validationContext">
          <b-form-group
            :id="'input-group-62-' + index"
            label="Код информации"
            :label-for="'input-62-' + index"
            :label-class="(!!item.ServiceInfoCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :id="'input-62-' + index"
              :class="(!!item.ServiceInfoCode) ? 'form-input filled-field' : 'form-input'"
              v-model="item.ServiceInfoCode"
              placeholder="Код информации"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <validation-provider
          ref="InfoDescription"
          name="Специальные требования и другая информация"
          :rules="{ max: 250 }"
          v-slot="validationContext">
          <b-form-group
            :id="'input-group-62-' + index"
            label="Специальные требования и другая информация"
            :label-for="'input-62-' + index"
            :label-class="(!!item.InfoDescription) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :id="'input-62-' + index"
              :class="(!!item.InfoDescription) ? 'form-input filled-field' : 'form-input'"
              v-model="item.InfoDescription"
              placeholder="Специальные требования и другая информация"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="NotifOrg_Name"
          name="Организация или лицо для уведомления о прибытии груза"
          :rules="{ max: 150 }"
          v-slot="validationContext">
          <b-form-group
            :id="'input-group-15-' + index"
            label="Организация или лицо для уведомления о прибытии груза"
            :label-for="'input-15-' + index"
            :label-class="(!!item.NotifOrg_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :id="'input-15-' + index"
              :class="{ 'form-input': true, 'filled-field': (!!item.NotifOrg_Name) }"
              v-model="item.NotifOrg_Name"
              placeholder="Организация или лицо для уведомления о прибытии груза"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="NotifOrg_Phone"
          name="Телефон"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-10"
            label="Телефон"
            label-for="input-10"
            :label-class="(!!item.NotifOrg_Phone) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-10"
              :class="(!!item.NotifOrg_Phone) ? 'form-input filled-field' : 'form-input'"
              v-model="item.NotifOrg_Phone"
              placeholder="Телефон"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="NotifOrg_Email"
          name="Электронная почта"
          :rules="{ max: 35, regex: /^[^@]+@\w+(\.\w+)+\w$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-11"
            label="Электронная почта"
            label-for="input-11"
            :label-class="(!!item.NotifOrg_Email) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-11"
              :class="(!!item.NotifOrg_Email) ? 'form-input filled-field' : 'form-input'"
              v-model="item.NotifOrg_Email"
              placeholder="Электронная почта"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="NotifOrg_INN"
            :name="'ИНН'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-23"
              label="ИНН"
              label-for="input-23"
              :label-class="(!!item.NotifOrg_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-23"
                :class="(!!item.NotifOrg_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="item.NotifOrg_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="NotifOrg_KPP"
            :name="'КПП'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-24"
              label="КПП"
              label-for="input-24"
              :label-class="(!!item.NotifOrg_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-24"
                :class="(!!item.NotifOrg_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="item.NotifOrg_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="NotifOrg_OGRN"
            :name="'ОГРН'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-25"
              label="ОГРН"
              label-for="input-25"
              :label-class="(!!item.NotifOrg_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-25"
                :class="(!!item.NotifOrg_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="item.NotifOrg_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
           inputName="Буквенный код страны"
          :ref="'NotifOrg_CountryCode-' + index"
          :inputId="'NotifOrg_CountryCode-' + index"
          :index="index"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { NotifOrg_CountryCode: 'abc2' },
            { NotifOrg_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          inputName="Наименование страны"
          :ref="'NotifOrg_CountryName-' + index"
          :inputId="'NotifOrg_CountryName-' + index"
          :index="index"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { NotifOrg_CountryCode: 'abc2' },
            { NotifOrg_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="NotifOrg_PostalCode"
            :name="'Индекс'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-28"
              label="Почтовый индекс"
              label-for="input-28"
              :label-class="(!!item.NotifOrg_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-28"
                :class="(!!item.NotifOrg_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="item.NotifOrg_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            :ref="'NotifOrg_Region-' + index"
            :inputId="'NotifOrg_Region-' + index"
            :index="index"
            inputName="Область (регион, штат, провинция и т.п.)"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="NotifOrg_City"
            :name="'Населенный пункт'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-30"
              label="Населенный пункт"
              label-for="input-30"
              :label-class="(!!item.NotifOrg_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-30"
                :class="(!!item.NotifOrg_City) ? 'form-input filled-field' : 'form-input'"
                v-model="item.NotifOrg_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            :ref="'NotifOrg_StreetHouse-' + index"
            :inputId="'NotifOrg_StreetHouse-' + index"
            :index="index"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    </div>
    </b-collapse>
    <h4 class="form-title">Оформлено</h4>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <custom-datepicker
          ref="RegDate"
          inputId="RegDate"
          inputName="Дата составления накладной"
          :disabled="notForEdit"
          :required="true"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/, required: true }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="12" cols="12">
        <validation-provider
          ref="Place"
          :name="'Место составления накладной'"
          :rules="{ required: true, max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-1"
            label="Место составления накладной"
            label-for="input-1"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!airWaybillForm.Place), 'empty-field': !(!!airWaybillForm.Place) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-1"
              :class="{ 'form-input': true, 'filled-field': (!!airWaybillForm.Place), 'required-field': !(!!airWaybillForm.Place) }"
              v-model="airWaybillForm.Place"
              placeholder="Место составления накладной"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <h4 class="form-subtitle">Подпись перевозчика или его Агента</h4>
    <b-row>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="Carrier_PersonSurname"
          name="Фамилия"
          v-slot="validationContext">
          <b-form-group
            id="input-group-35"
            label="Фамилия"
            label-for="input-35"
            :label-class="(!!airWaybillForm.Carrier_PersonSurname) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-35"
              :class="(!!airWaybillForm.Carrier_PersonSurname) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Carrier_PersonSurname"
              placeholder="Фамилия"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="Carrier_PersonName"
          name="Имя"
          v-slot="validationContext">
          <b-form-group
            id="input-group-36"
            label="Имя"
            label-for="input-36"
            :label-class="(!!airWaybillForm.Carrier_PersonName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-36"
              :class="(!!airWaybillForm.Carrier_PersonName) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Carrier_PersonName"
              placeholder="Имя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="Carrier_PersonMiddleName"
          name="Отчество"
          v-slot="validationContext">
          <b-form-group
            id="input-group-36"
            label="Отчество"
            label-for="input-36"
            :label-class="(!!airWaybillForm.Carrier_PersonMiddleName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-36"
              :class="(!!airWaybillForm.Carrier_PersonMiddleName) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Carrier_PersonMiddleName"
              placeholder="Отчество"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="Carrier_PersonPost"
          name="Должность"
          v-slot="validationContext">
          <b-form-group
            id="input-group-36"
            label="Должность"
            label-for="input-36"
            :label-class="(!!airWaybillForm.Carrier_PersonPost) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-36"
              :class="(!!airWaybillForm.Carrier_PersonPost) ? 'form-input filled-field' : 'form-input'"
              v-model="airWaybillForm.Carrier_PersonPost"
              placeholder="Должность"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import CustomInput from '../../CustomInput'
  import CustomDatepicker from '../../CustomDatepicker'

  export default {
    name: "WaybillExpressIndividualPage",
    props: ['getValidationState', 'airWaybill', 'targetInput', 'notForEdit'],
    components: {
      CustomInput,
      CustomDatepicker,
    },
    data () {
      return {
        promise: window.Promise,
        airWaybillForm: {
          did: null,
          DOC_ID: null,
          RegNum: null,
          IataCode: null,
          Place: null, //Место составления накладной
          RegDate: null, //Дата составления накладной
          Consignor_Name: null, // Отправитель: наименование
          Consignor_OGRN: null, // Отправитель: ОГРН (для РФ), БИН (для Казахстана)
          Consignor_INN: null, // Отправитель:ИНН (в соответствии с национальной системой кодирования)
          Consignor_KPP: null, // Отправитель: КПП
          Consignor_Phone: null, // Отправитель: 
          Consignor_Email: null, // Отправитель: 
          Consignor_CountryName: null, // Отправитель: наименование страны
          Consignor_CountryCode: null, // Отправитель: буквенный код страны
          Consignor_PostalCode: null, // Отправитель: почтовый индекс
          Consignor_Region: null, // Отправитель: область (регион, штат, провинция и т.п.)
          Consignor_City: null, // Отправитель: населенный пункт
          Consignor_StreetHouse: null, // Отправитель: улица, номер дома, номер офиса
          Consignee_Name: null, // Получатель: наименование
          Consignee_OGRN: null, // Получатель: ОГРН (для РФ), БИН (для Казахстана)
          Consignee_INN: null, // Получатель:ИНН (в соответствии с национальной системой кодирования)
          Consignee_KPP: null, // Получатель: КПП
          Consignee_Phone: null, // Получатель:
          Consignee_Email: null, // Получатель:
          Consignee_CountryCode: null, // Получатель: буквенный код страны
          Consignee_CountryName: null, // Получатель: наименование страны
          Consignee_PostalCode: null, // Получатель: почтовый индекс
          Consignee_Region: null, // Получатель: область (регион, штат, провинция и т.п.)
          Consignee_City: null, // Получатель: населенный пункт
          Consignee_StreetHouse: null, // Получатель: улица, номер дома, номер офиса
          IssuingCarrier_Name: null, // Агент выпускающего перевозчика
          IssuingCarrier_INN: null,
          IssuingCarrier_OGRN: null,
          IssuingCarrier_KPP: null,
          IssuingCarrier_Phone: null,
          IssuingCarrier_Email: null,
          IssuingCarrier_CountryCode: null, // Перевозчик: буквенный код страны
          IssuingCarrier_CountryName: null, // Перевозчик: наименование страны
          IssuingCarrier_PostalCode: null, // Перевозчик: почтовый индекс
          IssuingCarrier_Region: null, // Перевозчик: область (регион, штат, провинция и т.п.)
          IssuingCarrier_City: null, // Перевозчик: населенный пункт
          IssuingCarrier_StreetHouse: null, // Перевозчик: улица, номер дома, номер офиса
          IssuingCarrier_IATACode: null,
          IssuingCarrier_CommissionFlag: null, // Сведения о  комиссионных для агента. "1"- "Агенту полагаются комиссионные"; "0" - запись отсутствует
          IssueInfo_Name: null, // Авиакомпания, выписавшая накладную
          IssueInfo_INN: null,
          IssueInfo_OGRN: null,
          IssueInfo_KPP: null,
          IssueInfo_Phone: null,
          IssueInfo_Email: null,
          IssueInfo_CountryCode: null, // Перевозчик: буквенный код страны
          IssueInfo_CountryName: null, // Перевозчик: наименование страны
          IssueInfo_PostalCode: null, // Перевозчик: почтовый индекс
          IssueInfo_Region: null, // Перевозчик: область (регион, штат, провинция и т.п.)
          IssueInfo_City: null, // Перевозчик: населенный пункт
          IssueInfo_StreetHouse: null, // Перевозчик: улица, номер дома, номер офиса
          DepPoint_IATACode: null, //Аэропорт отправления
          DepPoint_Name: null, //Аэропорт отправления: название
          AWBGoodsMovement: { //авиаперевозчик
            AWBGOODSMOVEMENT_ITEM: [
              {  
                DOC_ID: null,
                FlightNumber: null,
                FlightDateNew: null,
                NumPP: null,
                IATACode: null,
                CarrierName: null,
                CarrierCode: null,
              }
            ]
          },
          DestPoint_IATACode: null, //Аэропорт назначения
          DestPoint_Name: null, //Аэропорт назначения: название
          DestinationOfficeIdentifier: null, //Код таможенного органа назначения
          DestinationOfficeName: null, //Наименование таможенного органа назначения
          Carrier_PersonPost: null, //Подпись перевозчика Должность
          Carrier_PersonSurname: null, //Подпись перевозчика Фамилия
          Carrier_PersonName: null, //Подпись перевозчика Имя
          Carrier_PersonMiddleName: null, //Подпись перевозчика
          AWBHandlingInfo: {
            AWBHANDLINGINFO_ITEM: [
              {
                DOC_ID: null,
                ServiceInfoCode: null,
                InfoDescription: null,
                NotifOrg_Name: null,
                NotifOrg_OGRN: null,
                NotifOrg_INN: null,
                NotifOrg_KPP: null,
                NotifOrg_Phone: null,
                NotifOrg_Email: null,
                NotifOrg_PostalCode: null,
                NotifOrg_CountryCode: null,
                NotifOrg_CountryName: null,
                NotifOrg_Region: null,
                NotifOrg_City: null,
                NotifOrg_StreetHouse: null,
              }
            ]
          }
        },
        collapseCarrierVisible: false,
        collapseAWBHandlingVisible: false,
        commissionFlagTypes: [
          { value: '1', text: 'Агенту полагаются комиссионные' },
          { value: '0', text: 'Запись отсутствует' },
        ],
      }
    },
    watch: {
      airWaybill (val) {
        if (val) {
          this.airWaybillForm = Object.assign(this.airWaybillForm, val.data)
          this.airWaybillForm.did = val.did
          for (let key in this.airWaybillForm) {
            if ((key === 'RegDate') ||
                (key === 'Consignor_CountryCode') ||
                (key === 'Consignor_CountryName') ||
                (key === 'Consignee_CountryCode') ||
                (key === 'Consignee_CountryName') ||
                (key === 'Consignor_Region') ||
                (key === 'Consignee_Region') ||
                (key === 'Consignor_StreetHouse') ||
                (key === 'Consignee_StreetHouse') ||
                (key === 'IssueInfo_CountryCode') ||
                (key === 'IssueInfo_CountryName') ||
                (key === 'IssuingCarrier_CountryCode') ||
                (key === 'IssuingCarrier_CountryName') ||
                (key === 'IssueInfo_Region') ||
                (key === 'IssueInfo_StreetHouse') ||
                (key === 'IssuingCarrier_Region') ||
                (key === 'IssuingCarrier_StreetHouse') ||
                (key === 'IssuingCarrier_IATACode') ||
                (key === 'IssueInfo_IATACode') ||
                (key === 'IssuingCarrier_CommissionFlag') ||
                (key === 'DepPoint_IATACode') ||
                (key === 'DepPoint_Name') ||
                (key === 'DestPoint_IATACode') ||
                (key === 'DestPoint_Name') ||
                (key === 'RegDate') ||
                (key === 'Insurance_PaymentType')) {
                this.$refs[key].model = this.airWaybillForm[key]
            }
          }
          for (let i = 0; i < this.airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM.length; i++) {
            this.$nextTick(() => {
              this.$refs['CarrierCode-' + i][0].model = this.airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM[i].CarrierCode
              this.$refs['CarrierName-' + i][0].model = this.airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM[i].CarrierName
              this.$refs['CarrierName-' + i][0].model = this.airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM[i].CarrierName
              this.$refs['IATACode-' + i][0].model = this.airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM[i].IATACode
              this.$refs['FlightDateNew-' + i][0].model = this.airWaybillForm.AWBGoodsMovement.AWBGOODSMOVEMENT_ITEM[i].FlightDateNew
            })
          }
          for (let i = 0; i < this.airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM.length; i++) {
            this.$nextTick(() => {
              this.$refs['NotifOrg_CountryCode-' + i][0].model = this.airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM[i].NotifOrg_CountryCode
              this.$refs['NotifOrg_CountryName-' + i][0].model = this.airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM[i].NotifOrg_CountryName
              this.$refs['NotifOrg_Region-' + i][0].model = this.airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM[i].NotifOrg_Region
              this.$refs['NotifOrg_StreetHouse-' + i][0].model = this.airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM[i].NotifOrg_StreetHouse
            })
          }
        }
      },
    },
    computed: {
      ...mapState(
        {
          nsiProcedures: state => state.commissionShipment.nsiProcedures,
          nsiCurrency: state => state.houseShipment.nsiCurrency,
          nsiCountries: state => state.commissionShipment.nsiCountries,
          nsiIdentityDocuments: state => state.houseShipment.nsiIdentityDocuments,
          nsiAirports: state => state.houseShipment.nsiAirports,
        }
      )
    },
    mounted () {
    },
    methods: {
      setModel (event) {
        this.airWaybillForm[event.fieldName] = event.item
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      setRelated (event) {
        event.relatedFields.map((field) => {
          const key = Object.keys(field)[0]
          this.airWaybillForm[key] = event.item[field[key]]
          if (/^\d{4}-\d{2}-\d{2}$/.test(event.item[field[key]])) {
            let date = event.item[field[key]].split('-')
            date = date[2] + '.' + date[1] + '.' + date[0]
            this.$refs[key].model = date
          } else {
            this.$refs[key].model = event.item[field[key]]
          }
          return field
        })
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      setVisible (event) {
        this.isRefVisible = event
      },
      updateIdbData () {
        this.$emit('updateAirWaybill')
        },
      async removeDocuments (index) {
        if (!(this.airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM.length === 1)) {
          this.airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM.splice(index, 1)
        }
        await this.updateIdbData()
      },
      addDocuments () {
        this.airWaybillForm.AWBHandlingInfo.AWBHANDLINGINFO_ITEM.push(
          { 
            DOC_ID: null,
            ServiceInfoCode: null,
            InfoDescription: null,
            NotifOrg_Name: null,
            NotifOrg_OGRN: null,
            NotifOrg_INN: null,
            NotifOrg_KPP: null,
            NotifOrg_Phone: null,
            NotifOrg_Email: null,
            NotifOrg_PostalCode: null,
            NotifOrg_CountryCode: null,
            NotifOrg_CountryName: null,
            NotifOrg_Region: null,
            NotifOrg_City: null,
            NotifOrg_StreetHouse: null,
          }
        )
      },
      resetFormData () {
        const props = Object.getOwnPropertyNames(this.airWaybillForm)
        for (let i = 0; i < props.length; i++) {
          this.airWaybillForm[props[i]] = null
          if (this.$refs[props[i]]) {
            this.$refs[props[i]].model = null
          }
        }
      },
      ...mapActions({
        loadNsiProcedures: 'commissionShipment/loadNsiProcedures',
        loadNsiCurrency: 'houseShipment/loadNsiCurrency',
        loadNsiCountries: 'commissionShipment/loadNsiCountries',
        loadNsiIdentityDocuments: 'houseShipment/loadNsiIdentityDocuments',
        loadNsiAirports: 'houseShipment/loadNsiAirports',
      })
    }
  }
</script>

<style lang="scss" scoped>
  .reset-file-btn {
    height: 28px;
  }
  .form-input-wrapper {
    position: relative !important;
    & .nsi-tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }
  hr {
    margin-top: 0 !important;
  }
</style>
